import { HStack } from '@chakra-ui/react';
import React from 'react';

import type { Transaction, TransactionType } from 'types/api/transaction';

import type { BadgeProps } from 'toolkit/chakra/badge';
import { Badge } from 'toolkit/chakra/badge';
import StatusTag from 'ui/shared/statusTag/StatusTag';

interface Props {
  types: Array<TransactionType>;
  status: Transaction['status'];
  errorText?: string | null;
  isLoading?: boolean;
}

const TYPES_ORDER: Array<TransactionType> = [
  'blob_transaction',
  'rootstock_remasc',
  'rootstock_bridge',
  'token_creation',
  'contract_creation',
  'token_transfer',
  'contract_call',
  'coin_transfer',
];

const TYPE_LABELS: Record<TransactionType, { label: string; colorPalette: BadgeProps['colorPalette'] }> = {
  blob_transaction: { label: 'تراکنش Blob', colorPalette: 'yellow' },
  rootstock_remasc: { label: 'تراکنش REMASC', colorPalette: 'blue' },
  rootstock_bridge: { label: 'انتقال پل', colorPalette: 'blue' },
  token_creation: { label: 'ایجاد توکن', colorPalette: 'orange' },
  contract_creation: { label: 'ایجاد قرارداد', colorPalette: 'blue' },
  token_transfer: { label: 'انتقال توکن', colorPalette: 'orange' },
  contract_call: { label: 'فراخوانی قرارداد', colorPalette: 'blue' },
  coin_transfer: { label: 'انتقال SABA', colorPalette: 'orange' },
};

const TxTypeWithStatus = ({ types, status, errorText, isLoading }: Props) => {
  const typeToShow = [ ...types ].sort((first, second) => TYPES_ORDER.indexOf(first) - TYPES_ORDER.indexOf(second))[0];
  const type = typeToShow ? TYPE_LABELS[typeToShow] : { label: 'تراکنش', colorPalette: 'purple' as const };

  const statusTag = (() => {
    switch (status) {
      case 'ok':
        return <StatusTag type="ok" text="موفق" loading={ isLoading }/>;
      case 'error':
        return <StatusTag type="error" text="ناموفق" errorText={ errorText } loading={ isLoading }/>;
      case null:
        return <StatusTag type="pending" text="در انتظار" loading={ isLoading }/>;
      case undefined:
        return <StatusTag type="pending" text="نامشخص" loading={ isLoading }/>;
    }
  })();

  return (
    <HStack gap={ 2 } flexWrap="wrap">
      <Badge colorPalette={ type.colorPalette } loading={ isLoading }>
        { type.label }
      </Badge>
      { statusTag }
    </HStack>
  );
};

export default React.memo(TxTypeWithStatus);
